import { useMutation, useQuery } from "@tanstack/react-query";

import { useAxios, useApiResponseParser, useAuth } from "../";

export default function useUser() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();
    const { selectedOrganization } = useAuth();

    function useList(organizationId?: string) {
        const orgId = organizationId ?? selectedOrganization?.Id;

        return useQuery({
            queryKey: ["users", orgId ?? "none"],
            queryFn: async () => {
                const response = await axiosPrivate.get(`/v1/user/list`, {
                    params: { OrganizationId: orgId },
                });
                return parseSuccessResponseData(response);
            },
            enabled: !!orgId,
        });
    }

    function useGetUserById() {
        return useMutation({
            mutationFn: (parameters: { id: string; OrganizationId: string }) =>
                axiosPrivate
                    .get(`/v1/user/list/${parameters.id}`, {
                        params: { OrganizationId: parameters.OrganizationId },
                    })
                    .then(parseSuccessResponseData),
        });
    }

    function useCreateCognito() {
        return useMutation({
            mutationFn: (parameters: {
                Email: string;
                FirstName: string;
                LastName: string;
                Password?: string;
                RoleId?: string;
                OrganizationId: string;
            }) => axiosPrivate.post(`/v1/user/create-cognito`, parameters).then(parseSuccessResponseData),
        });
    }

    return { useList, useGetUserById, useCreateCognito };
}
